// extracted by mini-css-extract-plugin
export default {"card":"BalanceCard_card__aRpJN","info":"BalanceCard_info__5-GBK"};